/** Whatever goes in, what comes out won't be less than zero. */
var minZero = function minZero(n) {
  return Math.max(0, n);
};
/** Generate an array of numbers, counting from zero to the provided number - 1. */

var arrayOfNumbers = function arrayOfNumbers(n) {
  return new Array(n).fill(0, 0, n).map(function (_v, i) {
    return i;
  });
};

export { arrayOfNumbers, minZero };
